// Import style lib
import { css } from 'styled-components';

// Import fonts files
import NunitoRegular from '../../assets/fonts/Nunito/Nunito-Regular.ttf';
import NunitoItalic from '../../assets/fonts/Nunito/Nunito-Italic.ttf';
import NunitoBold from '../../assets/fonts/Nunito/Nunito-Bold.ttf';
import NunitoBoldItalic from '../../assets/fonts/Nunito/Nunito-BoldItalic.ttf';

// Import the fonts as CSS font-face
const Fonts = css`
    @font-face {
        font-family: 'Nunito';
        src: url(${NunitoRegular}) format('truetype');
        font-weight: 400;
        font-style: normal;
    }

    @font-face {
        font-family: 'Nunito';
        src: url(${NunitoItalic}) format('truetype');
        font-weight: 400;
        font-style: italic;
    }

    @font-face {
        font-family: 'Nunito';
        src: url(${NunitoBold}) format('truetype');
        font-weight: 700;
        font-style: normal;
    }

    @font-face {
        font-family: 'Nunito';
        src: url(${NunitoBoldItalic}) format('truetype');
        font-weight: 700;
        font-style: italic;
    }
`;

export default Fonts;
